import {
    MailOutline,
    Phone,
    Room,
} from "@material-ui/icons";
import styled from "styled-components";
import { mobile, tablet } from "../responsive";
import { Link } from "react-router-dom";

const Wrapper = styled.div`
    background: var(--brand-surface);
    color: var(--brand-white);
    border-top: 1px solid var(--brand-rule);
`;

const Container = styled.div`
    padding: 2.5rem 5rem;
    display: flex;
    background: var(--brand-surface);
    font-family: "FuturaPT-Demi", sans-serif;
    ${mobile({ flexDirection: "column", padding: "0" })}
    ${tablet({ flexDirection: "column", padding: "0" })}
`;

const Left = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 20px;
    ${mobile({
        padding: "2rem 1.5rem",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
    })}
    ${tablet({
        padding: "2rem 1.5rem",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
    })}
`;

const Logo = styled.img`
    max-height: 3.25rem;
    width: auto;
    max-width: 16rem;
    display: block;
    ${mobile({ maxHeight: "2.75rem", maxWidth: "14rem" })};
    ${tablet({ maxHeight: "2.75rem", maxWidth: "14rem" })};
`;

const Desc = styled.p`
    margin: 1.25rem 0;
    color: var(--brand-muted);
    line-height: 1.6;
    max-width: 22rem;
`;

const SocialContainer = styled.div`
    display: flex;
    gap: 0.35rem;
`;

const SocialIcon = styled.a`
    cursor: pointer;
    width: 40px;
    height: 40px;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: opacity 0.25s ease;

    &:hover {
        opacity: 0.8;
    }

    img {
        width: 100%;
        height: auto;
    }
`;

const Center = styled.div`
    flex: 1;
    padding: 20px;
    ${mobile({ display: "none" })}
    ${tablet({ display: "none" })}
`;

const Title = styled.h3`
    margin-bottom: 1.5rem;
    color: var(--brand-gold);
    font-family: "Molde-Expanded-Regular", sans-serif;
    font-size: 1.15rem;
    letter-spacing: 0.08em;
    text-transform: uppercase;
`;

const DesktopOnlyTitle = styled(Title)`
    ${mobile({ display: "none" })}
    ${tablet({ display: "none" })}
`;

const List = styled.ul`
    margin: 0;
    padding: 0;
    list-style: none;
    display: grid;
`;

const FooterLink = styled(Link)`
    text-decoration: none;
    color: var(--brand-white);
    margin-bottom: 0.75rem;
    letter-spacing: 0.06em;
    transition: color 0.25s ease;

    &:hover {
        color: var(--brand-gold);
    }
`;

const Right = styled.div`
    flex: 1;
    padding: 20px;
    color: var(--brand-muted);
    ${mobile({ padding: "0 1.5rem 2rem" })}
    ${tablet({ padding: "0 1.5rem 2rem" })}
`;

const ContactItem = styled.div`
    margin-bottom: 1.15rem;
    display: flex;
    align-items: flex-start;
    line-height: 1.5;
    color: var(--brand-muted);

    svg {
        color: var(--brand-gold);
        margin-top: 2px;
        flex-shrink: 0;
    }
`;

const CopyrightContainer = styled.div`
    font-family: "Molde-Expanded-Bold", sans-serif;
    background: var(--brand-black);
    color: var(--brand-muted);
    padding: 1.25rem 5rem;
    display: flex;
    justify-content: center;
    border-top: 1px solid var(--brand-rule);
    ${mobile({ flexDirection: "column", padding: "1.25rem 1.5rem" })}
    ${tablet({ flexDirection: "column", padding: "1.25rem 1.5rem" })}
`;

const Copyright = styled.div`
    text-align: center;
    font-size: 0.95rem;
    letter-spacing: 0.04em;
    ${mobile({ fontSize: "0.8rem" })}
    ${tablet({ fontSize: "0.9rem" })}
`;

export const Footer = () => {
    return (
        <Wrapper>
            <Container>
                <Left>
                    <Logo
                        src="https://ik.imagekit.io/dnddecpho/dndream/DD_LogoGold-300x53_9YWAdjFzX.png?updatedAt=1706110249831"
                        alt="D&Dream Property Group"
                    />
                    <Desc>
                        Embark on an exciting career journey with D&D Property
                        Group as we broaden our opportunities.
                    </Desc>
                    <SocialContainer>
                        <SocialIcon
                            href="http://facebook.com/dndpropertygrp"
                            target="blank"
                            rel="noreferrer"
                        >
                            <img
                                src="https://ik.imagekit.io/dnddecpho/dndream/D&D_WebsiteIcons-13_xd3LAOH6T.png?updatedAt=1719654780865"
                                alt="Facebook"
                            />
                        </SocialIcon>
                        <SocialIcon
                            href="http://instagram.com/dnd_propertygroup"
                            target="blank"
                            rel="noreferrer"
                        >
                            <img
                                src="https://venti-fans.com/wp-content/uploads/2025/03/DD_WebsiteIcons-14_YpkotnPUz.webp"
                                alt="Instagram"
                            />
                        </SocialIcon>
                    </SocialContainer>
                </Left>
                <Center>
                    <DesktopOnlyTitle>Menu</DesktopOnlyTitle>
                    <List>
                        <FooterLink to="/about">ABOUT</FooterLink>
                        <FooterLink to="/team">TEAM</FooterLink>
                        <FooterLink to="/training">TRAINING</FooterLink>
                        <FooterLink to="/contact">CONTACT</FooterLink>
                    </List>
                </Center>
                <Right>
                    <Title>Contact</Title>
                    <ContactItem>
                        <Room style={{ marginRight: "10px" }} /> D&Dream
                        Properties Sdn Bhd, G-22, Boulevard 28, Jalan Pandan
                        Perdana 3/10, Pandan Perdana, 55300 Kuala Lumpur
                    </ContactItem>
                    <ContactItem>
                        <Phone style={{ marginRight: "10px" }} /> +6 03 9202
                        5937
                    </ContactItem>
                    <ContactItem>
                        <MailOutline style={{ marginRight: "10px" }} />{" "}
                        dndpropertygrp@gmail.com
                    </ContactItem>
                </Right>
            </Container>
            <CopyrightContainer>
                <Copyright>
                    Copyright © 2026 D&Dream Properties Sdn. Bhd. All rights
                    reserved.
                </Copyright>
            </CopyrightContainer>
        </Wrapper>
    );
};
